import React from "react";
import { ICountry, IProvince } from "../interface/address";
import { IOrder } from "../interface/order";
import { IPayment } from "../interface/payment";
import { IPaymentMethod } from "../interface/paymentMethod";

export interface IAppState {
    paymentMethods: IPaymentMethod[];
    provinceList: IProvince[];
    countryList: ICountry[];
    orderDetail: IOrder;
    setOrderDetail: any;
}

export const appStateDefault: IAppState = {
    paymentMethods: [],
    countryList: [],
    provinceList: [],
    orderDetail: {} as any,
    setOrderDetail: () => {},
};

export const AppStateContext = React.createContext(appStateDefault);

export interface IPaymentState {
    payment: IPayment;
}

export const paymentStateDefault: IPaymentState = {
    payment: {} as any,
};

export const PaymentDetailContext = React.createContext(paymentStateDefault);
